import '../css/reset.css';
import '../css/common.css';
import '../css/style.min.css';
import '../css/pageCounseling.css';

import {
  requestGET,
  OLD_API_URL,
} from './common-es6.js';

function partnerImgSrc(partnerImg) {
  if (partnerImg) {
    return `https://assets.trost.co.kr/images/partner/${partnerImg}_.png`;
  }

  return 'https://assets.trost.co.kr/images/partner/15065781875627_.png';
}

function setLoader(el, type) {
  if (el) {
    return el.style.display = type;
  }
}

window.addEventListener('DOMContentLoaded', () => {
  requestGET(`${OLD_API_URL}/counseling/?type=counselingList&counselingNo=0`, (status, resData) => {
    if (!status || !resData) {
      setLoader(document.getElementById('counselingLoader'), 'none');
      return false;
    }

    const totalCounselingCount = (resData.data.list.length) ? resData.data.list.length : 0;

    if (!totalCounselingCount) {
      setLoader(document.getElementById('counselingLoader'), 'none');
      return false;
    }

    let recentlyMessage = '';
    let lastMessageSentAt = '';
    let unReadMessageCount = 0;
    let unReadMessageCountEl = '';
    let partnerName = '';
    let clientClass = '';
    const checkTherapySpecialist = false;

    for (let i = 0; i < totalCounselingCount; i += 1) {
      if (
        resData.data.list[i].result === 'H_Y'
          || resData.data.list[i].result === 'H_N'
          || resData.data.list[i].result === 'H_E_F'
          || resData.data.list[i].result === 'H_TS'
      ) {
        if (resData.data.list[i].result === 'H_Y' || resData.data.list[i].result === 'H_N') {
          partnerName = `${resData.data.list[i].partnerName} 상담사`;
        } else {
          partnerName = resData.data.list[i].partnerName;
        }

        lastMessageSentAt = (resData.data.list[i].lastMessageSentAt) ? resData.data.list[i].lastMessageSentAt.substring(0, 10) : ' - ';
        unReadMessageCount = resData.data.list[i].lastMessageNo - resData.data.list[i].lastReadMessageNo;
        unReadMessageCountEl = '';
        recentlyMessage = ((unReadMessageCount) && (unReadMessageCount > 0)) ? '새로운 메시지가 도착하였습니다.' : '마지막 메시지 입니다.';
        clientClass = (resData.data.list[i].result === 'H_TS') ? 'therapySpecialist' : resData.data.list[i].result;

        document.getElementsByClassName(`${clientClass}`)[0].innerHTML += `<a target='_self' href='/service/counseling/texttime/?no=${resData.data.list[i].counselingNo}'>`
            + `<ul id='${resData.data.list[i].counselingNo}' class='eachintro'>`
            + '<li>'
            + `<img src='${resData.data.list[i].partnerPic}' alt='상담사 프로필 이미지'>`
            + `<p>${partnerName}<br/><br/>`
            + `<span class='recently_message'>${recentlyMessage}</span><br/>`
            + `<span class='recently_time'>(${lastMessageSentAt}) ${unReadMessageCountEl}</span>`
            + '</p>'
            + '</li>'
            + '</ul>'
            + '</a>';
      }
    }

    setLoader(document.getElementById('counselingLoader'), 'none');

    if (!checkTherapySpecialist) {
      document.getElementsByClassName('therapySpecialist')[0].style.display = 'none';
    }
  });
});
